import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { DialogService, OnGetData } from '../../../services/dialog.service';
import { TenantService } from '../../../services/tenant.service';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';
import { ShareAssetLinkComponent } from '../../components/share-asset-link/share-asset-link.component';
import { ShareGalleryDialogComponent } from '../share-gallery-dialog/share-gallery-dialog.component';
import { ShareSubGalleryDialogComponent } from '../share-sub-gallery-dialog/share-sub-gallery-dialog.component';
import { WorkspaceDialogComponent } from '../workspace-dialog/workspace-dialog.component';

@Component({
  selector: 'app-share-asset-dialog',
  templateUrl: './share-asset-dialog.component.html',
  styleUrls: ['./share-asset-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ShareAssetLinkComponent, AssetUrlPipe, AsyncPipe],
})
export class ShareAssetDialogComponent implements OnGetData {
  private dialog = inject(DialogService);
  private tenantService = inject(TenantService);
  dialogName = 'share-asset';
  gallery = signal<GalleryDto>(undefined);
  asset = signal<AssetDto>(undefined);
  close: (...args) => void;
  hideAll = signal(false);

  dialogOptions(): DialogOptions {
    return { size: 560, hideClose: true, spacingX: 40, spacingY: 40 };
  }

  async onGetData(data: { gallery: GalleryDto; asset: AssetDto }, close: (...args) => void) {
    if (this.tenantService.shouldShowWorkspaceDialog(data.gallery)) {
      this.hideAll.set(true);
      return this.dialog.open(WorkspaceDialogComponent, {
        onDone: () => {
          if (data.gallery.section) {
            this.dialog.open(ShareSubGalleryDialogComponent, data);
          } else {
            this.dialog.open(ShareGalleryDialogComponent, data);
          }
        },
        item: data.gallery,
      });
    }

    this.gallery.set(data.gallery);
    this.asset.set(data.asset);
    this.close = close;
  }
}
